import { onMounted } from 'vue';
import VersionChecker from '@xuezhu/version-checker';

function useVersion() {
  onMounted(() => {
    try {
      const versionChecker = VersionChecker.createInstance({
        checkInterval: 30, // 检查间隔时间，单位为秒，默认为60秒
        checkOnWindowFocus: true, // 是否在窗口获得焦点时检查版本，默认为false
        // versionRequestFunc: async (baseUrl) => {
        //   const response = await fetch(`${baseUrl}/version.json?timestamp=` + Date.now())
        //   if (!response.ok) {
        //     throw new Error('网络响应不正常')
        //   }
        //   const data = await response.json()
        //   if (!data || typeof data.version !== 'string') {
        //     throw new Error('无效的版本数据')
        //   }
        //   return data.version
        // },
        consoleStyle: ['background: #333; color: #fff; padding: 2px 4px; border-radius: 3px 0 0 3px;', 'background: #ff6347; color: #fff; padding: 2px 4px; border-radius: 0 3px 3px 0;'],
      });
      versionChecker.on('update', () => {
        window.location.reload();
      });
    } catch (error) {
      console.log(error);
    }
  });
}
export default useVersion;
